import { put, takeEvery } from "redux-saga/effects";

import { ECONTRACT } from "constants/actionTypes";

import { synchronousActionHandler } from "sagas/lib";

import { api } from "./api";

function* dispatchShareLinkSuccess() {
  yield put({ type: ECONTRACT.SHARE.SUCCESS });
}

function* dispatchShareLinkFailure(action, error) {
  yield put({ type: ECONTRACT.SHARE.FAILURE, payload: error });
}

function* shareHandler(action) {
  const { eContractId, party } = action.payload;
  return yield api.post(`/v2/econtracts/${eContractId}/share/`, { party });
}

function* onRequestEContractShareLink(action) {
  yield synchronousActionHandler(
    action,
    shareHandler,
    dispatchShareLinkSuccess,
    dispatchShareLinkFailure,
  );
}

function* shareConfirmHandler(action) {
  const { eContractId, party } = action.payload;
  const response = yield api.post(
    `/v2/econtracts/${eContractId}/share_confirm/`,
    { party },
  );
  yield put({ type: ECONTRACT.SHARE_CONFIRM.SUCCESS, payload: response });
  return response;
}

function* onRequestEContractShareConfirm(action) {
  yield synchronousActionHandler(
    action,
    shareConfirmHandler,
    undefined,
    undefined,
  );
}

export default function* eContractsSaga() {
  yield takeEvery(ECONTRACT.SHARE.REQUEST, onRequestEContractShareLink);
  yield takeEvery(
    ECONTRACT.SHARE_CONFIRM.REQUEST,
    onRequestEContractShareConfirm,
  );
}
